/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');
var Syphon = require('backbone.syphon');
var Ladda = require('ladda');
var moment = require('moment');

var ExamHeaderBarView = require('../../common/views/ExamHeaderBarView');
var BreadcrumbView = require('common/views/BreadcrumbView');

var tmplNonDepExamEditGeneralInformationView = require('../templates/NonDepExamEditGeneralInformationView.hbs');
var SubmitUpdateExamGeneralInformation = require('../services/SubmitUpdateExamGeneralInformation');

module.exports = Marionette.LayoutView.extend({
  template: tmplNonDepExamEditGeneralInformationView,

  className: 'non-dep-exam-edit-general-information-view container-fluid',

  ui: {
    headerBarContainer: '.header-bar-container',
    breadCrumbContainer: '.breadcrumb-container',
    generalInformationForm: '.general-information-form',
    examDate: '.exam-date',
    examStartDate: '.exam-start-date',
    examEndDate: '.exam-end-date',
    examCoverageStartDate: '.exam-coverage-start-date',
    examCoverageEndDate: '.exam-coverage-end-date',
    examinerReviewedDate: '.examiner-reviewed-date',
    examinerReviewedTime: '.examiner-reviewed-time',
    regionalDirectorReviewedDate: '.regional-director-reviewed-date',
    regionalDirectorReviewedTime: '.regional-director-reviewed-time',
    cancelledDate: '.exam-cancelled-date',
    examTransmittalDate: '.exam-report-summary-transmissal-date',
    submit: '.submit'
  },

  regions: {
    headerBarContainer: '@ui.headerBarContainer',
    breadcrumbContainer: '@ui.breadCrumbContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var exam = this.model.get('exam') || {};
    var examId = exam.examId;

    this.showChildView(
      'headerBarContainer',
      new ExamHeaderBarView({
        model: new Backbone.Model(_.extend(this.model.get('exam'), { title: 'Exam' }))
      })
    );

    var entityName = this.model.get('exam').entityName;
    var entityId = this.model.get('exam').entityId;
    var licenseNumber = this.model.get('exam').licenseNumber;
    var licenseId = this.model.get('exam').licenseId;

    this.showChildView(
      'breadcrumbContainer',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#nondep/dashboard',
            text: 'Home'
          },
          {
            text: entityName,
            link: '#nondep/entity/' + entityId + '/dashboard'
          },
          {
            text: 'License #' + licenseNumber,
            link: '#nondep/entity/' + entityId + '/license/' + licenseId
          },
          {
            text: 'Exam #' + examId,
            link: '#nondep/dashboard/exam/' + examId
          },
          {
            text: 'Edit General Information'
          }
        ]
      })
    );

    this.formatDateTimes(exam);

    Syphon.deserialize(this, exam);

    this.ui.examDate.datepicker({});
    this.ui.examStartDate.datepicker({});
    this.ui.examEndDate.datepicker({});
    this.ui.examCoverageStartDate.datepicker({});
    this.ui.examCoverageEndDate.datepicker({});
    this.ui.examinerReviewedDate.datepicker({});
    this.ui.regionalDirectorReviewedDate.datepicker({});
    this.ui.cancelledDate.datepicker({});
    this.ui.examTransmittalDate.datepicker({});
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    var examId = this.model.get('exam').examId;
    var formData = this.getFormData();
    formData.examId = examId;
    this.validate().done(function() {
      var laddaContext = Ladda.create(self.ui.submit[0]);
      laddaContext.start();
      SubmitUpdateExamGeneralInformation(formData)
        .done(function() {
          Radio.channel('navigate').trigger('show:int:nd:dashboard:exams:dashboard', examId);
        })
        .fail(function(err) {
          laddaContext.stop();
        });
    });
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);

    return formData;
  },

  formatDateTimes: function(exam) {
    var EMPTY_SENTINEL = '--';
    var DATE_FMT = 'MM/DD/YYYY';
    var TIME_FMT = 'HH:mm';

    // datetime pairs
    var pairs = [
      ['regionalDirectorReviewedDate', 'regionalDirectorReviewedTime'],
      ['examinerReviewedDate', 'examinerReviewedTime']
    ];

    for (var i = 0; i < pairs.length; i++) {
      var dateKey = pairs[i][0];
      var timeKey = pairs[i][1];

      var dateValue = exam[dateKey];

      if (!dateValue || dateValue === EMPTY_SENTINEL) {
        exam[dateKey] = '';
        exam[timeKey] = '';
        continue;
      }

      var raw = new Date(dateValue);
      var m = moment(raw, moment.ISO_8601);

      exam[dateKey] = m.format(DATE_FMT);
      exam[timeKey] = m.format(TIME_FMT);
    }

    // simple date fields
    var dateFields = [
      'examDate',
      'examStartDate',
      'examEndDate',
      'examCoverageStartDate',
      'examCoverageEndDate',
      'cancelledDate',
      'examTransmittalDate'
    ];

    for (i = 0; i < dateFields.length; i++) {
      var key = dateFields[i];
      exam[key] = exam[key] !== EMPTY_SENTINEL ? exam[key] : '';
    }
  },

  validate: function() {
    return this.ui.generalInformationForm.parsley().whenValidate();
  }
});
